import { REDESIGN_COLORS, REDESIGN_FONTS } from '../../../constants';

export const SOFT_SHADOW = '0 1px 2px rgba(6, 63, 69, 0.06), 0 10px 26px rgba(6, 63, 69, 0.08)';
export const LIFT_SHADOW = '0 1px 2px rgba(6, 63, 69, 0.06), 0 14px 32px rgba(6, 63, 69, 0.12)';

// The visual skin of a login button, shared by the modal and the subscriptions
// page so the two cannot drift apart. Only the skin lives here - size and inner
// layout stay with each consumer, because the modal builds its buttons out of
// plain divs while the subscriptions page uses MUI's Button, which lays out its
// own label and icon.
export const socialSurface = {
    backgroundColor: REDESIGN_COLORS.white,
    border: `1px solid ${REDESIGN_COLORS.sand}`,
    borderRadius: '20px',
    boxShadow: SOFT_SHADOW,
    color: REDESIGN_COLORS.body,
    fontFamily: REDESIGN_FONTS.body,
    fontWeight: REDESIGN_FONTS.weightStrong,
    // The old buttons shouted in uppercase with wide tracking; the copy is
    // already sentence case, so both come off.
    textTransform: 'none',
    letterSpacing: 'normal',
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'border-color 150ms ease, box-shadow 150ms ease',
    '&:hover': {
        // MUI's contained Button supplies its own grey hover, so the surface
        // colour has to be restated here to keep these white.
        backgroundColor: REDESIGN_COLORS.white,
        borderColor: REDESIGN_COLORS.primary,
        boxShadow: LIFT_SHADOW,
    },
};
